import type { Dispatch } from 'react'
import React from 'react'
import {
  ButtonIconStyled,
  ButtonWrapper,
  ListItemWrapper,
  SearchTitle,
  HistoryHeader,
  ClearButton
} from './SearchHistory.styles'
import { Button, ListItem } from '@arvoreeducacao/bonsai-ds'
import { removeAllTerms, removeTermOfHistory } from './localStorageHistory'
import type { SearchHistoryType } from './searchHistory.types'
import { useTranslation } from 'i18n'

interface SearchHistoryListProps {
  searchs: SearchHistoryType[]
  setSearchs: Dispatch<Array<SearchHistoryType>>
  handleSubmit: (searchValue: string) => void
  compact?: boolean
}

const SearchHistoryList = ({
  searchs,
  setSearchs,
  handleSubmit,
  compact = false
}: SearchHistoryListProps) => {
  const { t } = useTranslation()

  const handleClearAll = () => {
    removeAllTerms()
    setSearchs([])
  }

  return (
    <>
      {compact ? (
        <HistoryHeader>
          <SearchTitle size={3}>{t('Suas buscas recentes')}</SearchTitle>
          <ClearButton
            data-testid="remove-all"
            theme={{ type: 'ghost', size: 'small' }}
            text={t('Limpar')}
            onClick={handleClearAll}
          />
        </HistoryHeader>
      ) : (
        <SearchTitle size={3}>{t('Suas buscas recentes')}</SearchTitle>
      )}
      {searchs.map(search => (
        <ListItemWrapper key={search.id}>
          <ListItem
            icon="time"
            data-testid={`list-item-${search.id}`}
            text={search.text}
            onClick={() => handleSubmit(search.text)}
          />
          <ButtonIconStyled
            data-testid={`remove-item-${search.id}`}
            iconName={'cancel'}
            theme={{ type: 'ghost', size: 'small' }}
            onClick={() => {
              removeTermOfHistory(search.id)
              setSearchs(searchs.filter(s => s.id !== search.id))
            }}
          />
        </ListItemWrapper>
      ))}
      {!compact && (
        <ButtonWrapper>
          <Button
            data-testid="remove-all"
            theme={{ type: 'secondary', size: 'large' }}
            text={t('Limpar buscas recentes')}
            onClick={handleClearAll}
          />
        </ButtonWrapper>
      )}
    </>
  )
}

export default SearchHistoryList
